import { useMemo } from 'react';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { erasmusTypeList } from '@/module/Travel/Request/model/TravelRequestTypes';

import { EnumSelectControl, EnumSelectControlProps } from '@/core/components';

export type ErasmusTypeSelectControlProps<T extends FieldValues> = Omit<EnumSelectControlProps<T>, 'options'>;

export function ErasmusTypeSelectControl<T extends FieldValues>(props: ErasmusTypeSelectControlProps<T>) {
  const { t } = useTranslation();
  const options = useMemo(
    () => erasmusTypeList.map(value => ({ value, label: t(`travel.erasmusTypeEnum.${value}`) })),
    [t],
  );

  return (
    <EnumSelectControl
      {...props}
      options={options}
    />
  );
}
